import { useEffect, useState } from 'react';
import { ApiHelper } from '../apiHelper/ApiHelper';
import { readJson } from '../apiHelper/readJson';
import { Journey } from '../pages/learningSpace/IndividualJourney';

// Fetches the student's online-lectures journey (group status, voting options,
// assigned term, first-lecture date) and keeps it in sync. The admin moves the
// group through its statuses in the admin space while the student may already
// have the page open, so we refetch whenever the tab regains focus — the new
// status then shows up without a hard reload. Returns null for students without
// a lecture journey (self-study, extra-hours only).
export function useJourney() {
    const api = new ApiHelper();
    const [journey, setJourney] = useState<Journey | null>(null);
    const [loading, setLoading] = useState(true);

    async function reload() {
        try {
            const res = await api.onlineLessonsApi.getJourneyList();
            setJourney(await readJson(res));
        } catch (x: any) {
            api.processErrors(x);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        reload();
        const resync = () => { if (document.visibilityState === "visible") reload().catch(() => {}); };
        window.addEventListener("focus", resync);
        document.addEventListener("visibilitychange", resync);
        return () => {
            window.removeEventListener("focus", resync);
            document.removeEventListener("visibilitychange", resync);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { journey, loading, reload };
}
